import { AlertCircle, Terminal } from "lucide-react";

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";

interface AlertBoxProps {
  variant?: "default" | "destructive";
  hideIcon?: boolean;
  title?: string;
  description: string;
  className?: any;
}

export function AlertBox(props: AlertBoxProps) {
  return (
    <Alert variant={props.variant || "default"} className={props.className}>
      {!props.hideIcon &&
        (props.variant === "destructive" ? (
          <AlertCircle className="h-4 w-4" />
        ) : (
          <Terminal className="h-4 w-4" />
        ))}

      {props.title && <AlertTitle>{props.title}</AlertTitle>}
      <AlertDescription>{props.description}</AlertDescription>
    </Alert>
  );
}
